import React from 'react'
import type { ComposeComponentImageFragment } from '../../../.graphql/generated-types'
import { PlainComposeComponentImage } from '../ComposeComponentImage/plain'

export interface ArticleHeroImageProps {
  data: ComposeComponentImageFragment
}

export function ArticleHeroImage(props: ArticleHeroImageProps) {
  return (
    <PlainComposeComponentImage data={props.data} width={940} height={529} />
  )
}
